import { Button } from '@shared/ui/kit';
import { PreviewChannelsList } from '@pages/event-send-invitations/ui/preview-summary-section/preview-channels-list';
import type { PreviewChannel } from '@pages/event-send-invitations/ui/preview-summary-section/preview-channels-item';
import styles from './preview-summary-section.module.scss';

interface TicketPreviewSummarySectionProps {
  onSendClick?: () => void;
  isSendDisabled?: boolean;
  eventName: string | null;
  eventDateLabel: string;
  ticketsCount: number;
  channels: PreviewChannel[];
}

export const TicketPreviewSummarySection = ({
  onSendClick,
  isSendDisabled = false,
  eventName,
  eventDateLabel,
  ticketsCount,
  channels,
}: TicketPreviewSummarySectionProps) => {
  return (
    <div className={styles.previewPanel}>
      <section className={styles.previewBody}>
        <header className={styles.previewEventHeader}>
          <h2 className={styles.previewEventTitle}>{eventName}</h2>
          <div className={styles.previewEventMeta}>
            <p className={styles.previewEventMetaText}>{eventDateLabel}</p>
          </div>
        </header>
        <div className={styles.previewDivider} />
        <section className={styles.previewSummaryCard}>
          <div className={styles.previewSummaryHeader}>
            <h3 className={styles.previewSummaryTitle}>Будет отправлено</h3>
            <p className={styles.previewSummaryTotals}>
              <span className={styles.previewSummaryTotalItem}>
                <span className={styles.previewSummaryTotalCount}>{ticketsCount}</span>
                <span className={styles.previewSummaryTotalText}>билетов</span>
              </span>
            </p>
          </div>
          <section className={styles.previewDeliverySection}>
            <div className={styles.previewDeliveryRow}>
              <h3 className={styles.previewDeliveryTitle}>Билеты</h3>
            </div>
            <PreviewChannelsList channels={channels} />
          </section>
        </section>
      </section>
      <Button
        variant="accent"
        size="medium"
        onClick={onSendClick}
        isDisabled={isSendDisabled}
        settings={{
          width: '100%',
          fontFamily: 'var(--font-family-din-regular)',
          fontSize: '18px',
        }}
      >
        Отправить
      </Button>
    </div>
  );
};
